import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RoomCard = ({ room, isSelected, onSelect }) => {
  return (
    <button
      onClick={() => onSelect(room)}
      className={`
        relative w-full bg-card border-2 rounded-lg overflow-hidden transition-all duration-300
        hover:shadow-lg hover:scale-[1.02]
        ${isSelected ? 'border-primary shadow-lg' : 'border-border'}
      `}
    >
      {isSelected && (
        <div className="absolute top-3 right-3 z-10 w-8 h-8 bg-primary rounded-full flex items-center justify-center">
          <Icon name="Check" size={18} color="white" />
        </div>
      )}
      <div className="aspect-video w-full overflow-hidden bg-muted">
        <Image
          src={room?.backgroundImage}
          alt={room?.backgroundImageAlt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-4 text-left">
        <h3 className="text-lg font-semibold text-text-primary mb-1">
          {room?.name}
        </h3>
        <p className="text-sm text-text-secondary line-clamp-2">
          {room?.description}
        </p>
      </div>
    </button>
  );
};

export default RoomCard;